if (!customElements.get('complementary-products')) {
  class ComplementaryProducts extends HTMLElement {
    connectedCallback() {
      this.syncVisibility = this.syncVisibility.bind(this);
      this.onVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.syncVisibility);
      this.onOptionChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => {
        requestAnimationFrame(this.syncVisibility);
      });
      this.syncVisibility();
    }

    disconnectedCallback() {
      this.onVariantChangeUnsubscriber?.();
      this.onOptionChangeUnsubscriber?.();
    }

    syncVisibility() {
      if (this.dataset.requireCompleteSet !== 'true') {
        this.hidden = false;
        return;
      }

      const completeOptionValueId = this.dataset.completeOptionValueId;
      if (!completeOptionValueId) {
        this.hidden = true;
        return;
      }

      const productInfo = this.closest('product-info') || document;
      const completeSelected = !!productInfo.querySelector(
        `variant-selects input[data-option-value-id="${completeOptionValueId}"]:checked`
      );

      this.hidden = !completeSelected;
    }
  }

  customElements.define('complementary-products', ComplementaryProducts);
}
